module.exports = __webpack_public_path__ + "images/4f21490d.exclusive_5_chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/exclusive/exclusive_5_chs.png
// module id = 455
// module chunks = 0